import { render, staticRenderFns } from "./editBank.vue?vue&type=template&id=0605c1fc"
import script from "./editBank.vue?vue&type=script&lang=js"
export * from "./editBank.vue?vue&type=script&lang=js"
import style0 from "./editBank.vue?vue&type=style&index=0&id=0605c1fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports